import { useState } from 'react';
import Modal from '../modal/Modal';
import { useModal } from '../modal/useModal';
import { showErrorNotification, showSuccessNotification } from '../../util/notifications';
import useApi from '../../api';
import classNames from 'classnames';
import { useQueryClient } from 'react-query';
import { QueryKey } from '../../constants/queryKey';
import RoleSelector from './RoleSelector';

const EditUserModal = ({ modalId, user }) => {
    const { closeModal } = useModal();
    const [isLoading, setIsLoading] = useState(false);
    const [role, setRole] = useState(user.role);
    const { editUser } = useApi();
    const queryClient = useQueryClient();

    const buttonClass = classNames('button', {
        'button--loading': isLoading,
    });

    const onSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await editUser(user.id, { role });
            await queryClient.invalidateQueries(QueryKey.Users);
            showSuccessNotification('User role updated.');
            closeModal(modalId);
        } catch (err) {
            const msg = err.response?.data?.error || 'Something went wrong updating the user.';
            showErrorNotification(msg);
        }
        setIsLoading(false);
    };

    return (
        <Modal modalId={modalId}>
            <h1 className="modal__title">Edit user</h1>
            <form onSubmit={onSubmit} noValidate className="form">
                <div className="form__group">
                    <label className="form__label">Email</label>
                    <div className="form__field" style={{ padding: '12px 15px' }}>{user.email}</div>
                </div>
                <div className="form__group">
                    <label className="form__label">Role</label>
                    <RoleSelector value={role} onChange={setRole} />
                </div>
                <div className="modal__footer">
                    <button type="button" className="button button--link" onClick={() => closeModal(modalId)}>Cancel</button>
                    <button type="submit" className={buttonClass}>Save</button>
                </div>
            </form>
        </Modal>
    );
};

export default EditUserModal;
